import { MonitoringKindDefinition } from '../Interfaces/monitoring-kind-definition.interface';
import { MonitoringStatusBucketDefinition } from '../Interfaces/monitoring-status-bucket-definition.interface';

export const MONITORING_KINDS: ReadonlyArray<MonitoringKindDefinition> = [
  { kind: 'applications', labelKey: 'app.reports.monitoring.kind.applications', tone: 'pending' },
  { kind: 'groups', labelKey: 'app.reports.monitoring.kind.groups', tone: 'progress' },
];

export const MONITORING_STATUS_BUCKETS: ReadonlyArray<MonitoringStatusBucketDefinition> = [
  { bucket: 'open', labelKey: 'app.reports.monitoring.status.open', tone: 'progress' },
  { bucket: 'approved', labelKey: 'app.reports.monitoring.status.approved', tone: 'success' },
  { bucket: 'rejected', labelKey: 'app.reports.monitoring.status.rejected', tone: 'error' },
  { bucket: 'canceled', labelKey: 'app.reports.monitoring.status.canceled', tone: 'muted' },
  { bucket: 'failed', labelKey: 'app.reports.monitoring.status.failed', tone: 'required' },
];

export const MONITORING_STATUS_ANNOUNCEMENT_KEYS = {
  shown: 'app.reports.monitoring.statusBreakdown.announce.shown',
  hidden: 'app.reports.monitoring.statusBreakdown.announce.hidden',
  allHidden: 'app.reports.monitoring.statusBreakdown.announce.allHidden',
} as const;
